<template>
  <div class="appBox">
    <header class="headBox">
      <img :src="logo" class="logoImg" />
      <div class="userBox">
        <a-tooltip size="small">
          <a-icon type="cloud" style="font-size: 18px;padding-right: 20px;padding-top: 7px;" @click="jump"/>
          <template slot="title">进入云平台</template>
        </a-tooltip>
        
        <a-popover v-model="visible" trigger="click" class="userImg">
          <a slot="content" @click="hide">退出登录</a>
          <a style="height:32px;display:flex;align-items:center;color: rgba(0, 0, 0, 0.65);">
            <img :src="portraitUrl" style="margin-right: 10px;width: 32px;height: 32px;"/>
            {{userName}}
          </a>
        </a-popover>
      </div>
    </header>
    <div class="bodyBox">
      <router-view />
    </div>
  </div>
</template>
<script>
import portraitUrl from '../../assets/images/portrait.png'
import {instance} from '@/Utils/axios'
import {baseUrl,adminUrl} from '@/Utils/url.js'
export default {
  data(){
    return {
      type: 'noside',
      portraitUrl,
      visible: false,
      logo: require('../../assets/images/logo_nhf.svg'),
    }
  },
  computed: {  
    userName() {
      return this.$store.state.userName;
    }
  },
  methods:{
    jump(){
      // let accessToken = window.localStorage.getItem('accessToken')
      // let refreshToken = window.localStorage.getItem('refreshToken')
      // let loginTime = window.localStorage.getItem('loginTime')
      // let userName = window.localStorage.getItem('userName')
      // let staffId = window.localStorage.getItem('staffId')
      // window.open(`${adminUrl}?accessToken=${accessToken}&refreshToken=${refreshToken}&loginTime=${loginTime}&userName=${userName}&staffId=${staffId}`)
      
      // window.open(adminUrl)
      let localUrl = instance.defaults.baseURL ? instance.defaults.baseURL : baseUrl
      let url = `${localUrl}iot-auth/oauth/render/newhope?clientUrl=${adminUrl}`
      window.open(url)
    },
    hide() {
      this.visible = false;
      this.$http.get('/iot-auth/oauth/logout/newhope').then(res => {
        let {success,data} = res || {}
        if(success){
          // 清除token userName
          window.localStorage.removeItem("accessToken");
          window.localStorage.removeItem("userName");
          window.localStorage.removeItem("staffId");
          window.localStorage.removeItem("loginTime");
          window.localStorage.removeItem("refreshToken");
          window.localStorage.setItem('ssoLoginOut',true)
          window.localStorage.removeItem("factoryId");
          window.localStorage.removeItem("factory");
          window.localStorage.removeItem("factoryName");
          window.localStorage.removeItem("userInfo");
          // window.location.href = data.url
          // this.$router.push("/login");
          let src = window.location.href;
          if(src.split('/#/')[0]){
            // let clientUrl = encodeURIComponent(src.split('/#/')[0] + '/#/checkLogin')
            // // let clientUrl = src.split('/#/')[0] + '/#/checkLogin'
            // // window.open(`${data.url}?service=${clientUrl}`, "_blank");
            // console.log('clientUrl',clientUrl)
            // this.$router.push("/checkLogin?loginOutSrc");
            // window.localStorage.setItem('loginOutSrc',`${data.url}?service=${clientUrl}`)
            // // window.location.href = `${data.url}?service=${clientUrl}`

            let localUrl = instance.defaults.baseURL ? instance.defaults.baseURL : baseUrl
            let clientUrl = `${localUrl}iot-auth/oauth/callback/newhope`
            // let clientUrl = `http://172.18.9.229:3002/#/checkLogin`
            let clientState = window.localStorage.getItem('clientState')
            this.$router.push("/checkLogin?loginOutSrc");
            // https://iam.liuheco.com/logout?response_type=code&client_id=dQpZsakEwHlqTMCO&scope=openid&state=DGoK30oZ5CBFk9Ks1mnEa&redirect_uri=http://localhost
            window.localStorage.setItem(
              "loginOutSrc",
              `${data.url}?response_type=code&client_id=dQpZsakEwHlqTMCO&scope=openid&state=${clientState}&redirect_uri=${clientUrl}`
            );
            
          }
        }
      })
    },
  }
}
</script>
<style lang='scss' scoped>

.headBox{
  height: 80px;
  background-color: #fff;
  border-bottom: 1px solid #f0f2f5;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding:0 20px;
}
.bodyBox{
  display: flex;
  height: calc(100vh - 80px);
  background-color: #f0f2f5;
}
.menuBox{
  width: 256px;
  height:100%;
}
.logoImg{
  // width: 100px;
  height: 34px;
  line-height: 80px;
  font-weight: bold;
  color: #1998f7;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  img{
    width: 110px;
  }
}
.userBox{
  margin-right:30px;
  display: flex;
}
</style>